import { UtilsProvider } from "../../common/providers/utils-provider.service";
import { OrganizationRole } from "../../common/models/organization-role";
import { User } from "../../common/models/user";
import { Athlete } from "../../common/models/athlete";
import { AthleteCoach } from "../../common/models/athlete-coach";
import { AthleteGuest } from "../../common/models/athlete-guest";
import { Coach } from "../../common/models/coach";
import { Guest } from "../../common/models/guest";
import { OrganizationMembership } from "../../common/models/organization-membership";

export class AthleteRights {
    public Ready: Promise<boolean> = new Promise<boolean>((resolve, reject) => {});
    private _itemRightsList: AthleteItemRightsList | null = null;
    private _screenRightsList: AthleteScreenRightList | null = null;
    private _paramsItem: AthleteItemRightsParams | null = null;
    private _paramsScreen: AthleteScreenRightsParams | null = null;
    private _bestOfItemRight = 10000;
    private _bestOfScreenRight = 10000;
    constructor(private _utils: UtilsProvider) {
        this.setDefault();
    }

    public evaluateItemRight(params: AthleteItemRightsParams): void {

        /**
         * Les paramètres reçus contiennent le athlete, le user.id
         * et le organizationId. Les droits évalués doivent répondrent
         * à la question : qu'est-ce que je (user.id) peux faire avec
         * cet athlète (athlete.id) dans cette organisation (organizationId)
         * avec mon rôle (this._bestOfItemRight).
         */

        this._paramsItem = params;
        this.setDefault();
        this.setBestOfRole();

        const athlete: Athlete = this._paramsItem.athlete;
        if (!this._itemRightsList) return;

        switch (this._bestOfItemRight) {
        case OrganizationRole.ID_ADMIN:
            // this._paramsItem.user est un admin
            // tous les athlètes
            this._itemRightsList.view = true;
            this._itemRightsList.edit = true;
             this._itemRightsList.lock = true;
            this._itemRightsList.delete = true;
            this._itemRightsList.changeCoaches = true;
            this._itemRightsList.changeTeams = true;
            this._itemRightsList.writeComms = true;
            this._itemRightsList.sendInvitation = true;
            break;

        case OrganizationRole.ID_SUPERCOACH:
            // this._paramsItem.user est un supercoach
            // tous les athlètes de son organisation
            const memberships = this._utils.findManyIn([athlete.userId], this._paramsItem.athleteMemberships, 'userId');
            const orgIds = this._utils.getKeyValues(memberships, 'organizationId');
            if (orgIds.indexOf(this._paramsItem.organizationId) > -1) {
                this._itemRightsList.view = true;
                this._itemRightsList.edit = true;
              this._itemRightsList.lock = true;
                this._itemRightsList.delete = true;
                this._itemRightsList.changeCoaches = true;
                this._itemRightsList.changeTeams = true;
                this._itemRightsList.writeComms = true;
                this._itemRightsList.chat = true;
                this._itemRightsList.sendInvitation = true;
            }
            break;

          case OrganizationRole.ID_COACH:
            // this._paramsItem.user est un coach
            // tous les athlètes ayant une relation avec lui
            const links = this._utils.findManyIn([athlete.id], this._paramsItem.athleteCoachRelations, 'athleteId');
            const coachIds = this._utils.getKeyValues(links, 'coachId');
            const me = this._paramsItem.user.coach?.id;

            if (coachIds.indexOf(me) > -1) {
                this._itemRightsList.view = true;
                this._itemRightsList.edit = true;
                this._itemRightsList.changeCoaches = true;
                this._itemRightsList.changeTeams = true;
                this._itemRightsList.writeComms = true;
                this._itemRightsList.chat = true;
            }
            break;

        case OrganizationRole.ID_ATHLETE:
            // this._paramsItem.user est un athlète
            // uniquement son profil
            this._itemRightsList.view = (this._paramsItem.user.id === athlete.userId);
            this._itemRightsList.edit = (this._paramsItem.user.id === athlete.userId);
            this._itemRightsList.writeComms = (this._paramsItem.user.id === athlete.userId);
            break;

        case OrganizationRole.ID_GUEST:
            // this._paramsItem.user est un invité
            // tous les athlètes ayant une relation avec lui
            // idem que le coach mais en lecture seule
            const guestLinks = this._utils.findManyIn([athlete.id], this._paramsItem.athleteGuestRelations, 'athleteId');
            const guestLinkIds = this._utils.getKeyValues(guestLinks, 'guestId');
            const guests = this._utils.findManyIn(guestLinkIds, this._paramsItem.guests, 'id');
            const guestIds = this._utils.getKeyValues(guests, 'userId');

            if (guestIds.indexOf(this._paramsItem.user.id) > -1) {
                this._itemRightsList.view = true;
            }
            break;

        default:
            // rien
        }
    }

    public evaluateScreenRights(params: AthleteScreenRightsParams): void {

        /**
         * Détermine les droits que l'utilisateur possède
         * pour les commandes générales des écrans.
         */

        this._paramsScreen = params;
        this.setDefault();
        this.setBestOfRole();

        if (!this._screenRightsList) return;

        switch (this._bestOfScreenRight) {
        case OrganizationRole.ID_ADMIN:
            // this._paramsItem.user est un admin
            this._screenRightsList.list = true;
            this._screenRightsList.add = true;
            this._screenRightsList.edit = true;
            this._screenRightsList.delete = true;
            this._screenRightsList.showCommunications = true;
            this._screenRightsList.showFeedbacks = true;
            this._screenRightsList.showFiles = true;
            this._screenRightsList.sendInvitation = true;
            break;

        case OrganizationRole.ID_SUPERCOACH:
            // this._paramsItem.user est un super-coach
            this._screenRightsList.list = true;
            this._screenRightsList.add = true;
            this._screenRightsList.edit = true;
            this._screenRightsList.delete = true;
            this._screenRightsList.showCommunications = true;
            this._screenRightsList.showFeedbacks = true;
            this._screenRightsList.showFiles = true;
            this._screenRightsList.sendInvitation = true;
            break;

        case OrganizationRole.ID_COACH:
            // this._paramsItem.user est un coach
            this._screenRightsList.list = true;
            this._screenRightsList.add = !this._paramsScreen.limitedCoach;
            this._screenRightsList.edit = true;
            this._screenRightsList.delete = false;
            this._screenRightsList.showCommunications = true;
            this._screenRightsList.showFeedbacks = true;
            this._screenRightsList.showFiles = true;
            break;

        case OrganizationRole.ID_ATHLETE:
            // this._paramsItem.user est un athlète
            this._screenRightsList.list = false;
            this._screenRightsList.add = false;
            this._screenRightsList.edit = true;
            this._screenRightsList.delete = false;
            this._screenRightsList.showCommunications = true;
            this._screenRightsList.showFeedbacks = true;
            this._screenRightsList.showFiles = true;
            break;

        case OrganizationRole.ID_GUEST:
            // this._paramsItem.user est un invité
            this._screenRightsList.list = true;
            this._screenRightsList.add = false;
            this._screenRightsList.edit = false;
            this._screenRightsList.delete = false;
            this._screenRightsList.showCommunications = false;
            this._screenRightsList.showFeedbacks = false;
            this._screenRightsList.showFiles = false;
            break;

        default:
            // rien
        }
    }

    public getItemRightsList(): AthleteItemRightsList {
      if (!this._itemRightsList) throw new Error('AthleteRights.getItemRightsList: _screenRightsList is null');

      return this._itemRightsList;
    }

    public getScreenRightsList(): AthleteScreenRightList {
      if (!this._screenRightsList) throw new Error('AthleteRights.getScreenRightsList: _screenRightsList is null');

      return this._screenRightsList;
    }

    public getItemParams(): AthleteItemRightsParams {
      if (!this._paramsItem) throw new Error('AthleteRights.getItemParams: _paramsItem is null');

      return this._paramsItem;
    }

    public getScreenParams(): AthleteScreenRightsParams {
      if (!this._paramsScreen) throw new Error('AthleteRights.getScreenParams: _paramsItem is null');

      return this._paramsScreen;
    }

    public getBestOfScreenRight(){
        return this._bestOfScreenRight;
    }

    public getBestOfItemRight(){
        return this._bestOfItemRight;
    }

    public get LIST() {
        if (this._screenRightsList) {
            return this._screenRightsList.list;
        }
        return false;
    }

    public get ADD() {
        if (this._screenRightsList) {
            return this._screenRightsList.add;
        }
        return false;
    }

    public get EDIT() {
        if (this._screenRightsList) {
            return this._screenRightsList.edit;
        }
        return false;
    }

    public get DELETE() {
        if (this._screenRightsList) {
            return this._screenRightsList.delete;
        }
        return false;
    }

    public get SHOW_FILES() {
        if (this._screenRightsList) {
            return this._screenRightsList.showFiles;
        }
        return false;
    }

    public get SHOW_COMMUNICATIONS() {
        if (this._screenRightsList) {
            return this._screenRightsList.showCommunications;
        }
        return false;
    }

    public get SHOW_FEEDBACKS() {
        if (this._screenRightsList) {
            return this._screenRightsList.showFeedbacks;
        }
        return false;
    }

    public get SEND_INVITATION() {
        if (this._screenRightsList){
            return this._screenRightsList.sendInvitation;
        }
        return false;
    }

    private setDefault(): void {

      this._itemRightsList = {
          view: false,
          edit: false,
          lock: false,
          delete: false,
          changeCoaches: false,
          changeTeams: false,
          writeComms: false,
          chat: false,
          sendInvitation: false,
        };

      this._screenRightsList = {
          list: false,
          add: false,
          edit: false,
          delete: false,
          showCommunications: false,
          showFeedbacks: false,
          showFiles: false,
          sendInvitation: false,
        };

        this._bestOfItemRight = 10000;
        this._bestOfScreenRight = 10000;
    }

    private setBestOfRole() {

        if (this._paramsItem && this._paramsItem.rolesIds.length > -1) {
            for (let i = 0; i < this._paramsItem.rolesIds.length; i++) {
                if (this._paramsItem.rolesIds[i] < this._bestOfItemRight) {
                    this._bestOfItemRight = this._paramsItem.rolesIds[i];
                }
            }
        }

        if (this._paramsScreen && this._paramsScreen.rolesIds.length > -1) {
            for (let i = 0; i < this._paramsScreen.rolesIds.length; i++) {
                if (this._paramsScreen.rolesIds[i] < this._bestOfScreenRight) {
                    this._bestOfScreenRight = this._paramsScreen.rolesIds[i];
                }
            }
        }
    }
}



export interface AthleteItemRightsList {
    view: boolean;
    edit: boolean;
    lock: boolean;
    delete: boolean;
    changeCoaches: boolean;
    changeTeams: boolean;
    writeComms: boolean;
    chat: boolean;
    sendInvitation: boolean;
}

const defaultRights: AthleteItemRightsList = {
  view: false,
  edit: false,
  lock: false,
  delete: false,
  changeCoaches: false,
  changeTeams: false,
  writeComms: false,
  chat: false,
  sendInvitation: false
};

export function mapUserRightsToAthleteItemRightsList(userRights: string[]): AthleteItemRightsList {
  const rights = { ...defaultRights };

  userRights.forEach(right => {
    if (right in rights) {
      rights[right as keyof AthleteItemRightsList] = true;
    }
  });

  return rights;
}

export interface AthleteScreenRightList {
    list: boolean;
    add: boolean;
    edit: boolean;
    delete: boolean;
    showFiles: boolean;
    showCommunications: boolean;
    showFeedbacks: boolean;
    sendInvitation: boolean;
}

export interface AthleteItemRightsParams {
    user: User;
    organizationId: number;
    athlete: Athlete;
    rolesIds: number[];
    athleteCoachRelations: AthleteCoach[];
    athleteGuestRelations: AthleteGuest[];
    athleteMemberships: OrganizationMembership[];
    coaches: Coach[];
    guests: Guest[];
}

export interface AthleteScreenRightsParams {
    rolesIds: number[];
    limitedCoach?: boolean;
}
